import React, { createContext, useState, useContext, useEffect } from 'react';
import { authService } from '../services/authService';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const initAuth = async () => {

            // 🚧 STOP everything if maintenance — the authService interceptors
            //    will clear this flag and fire 'maintenanceChange' once the
            //    server comes back, so no need to poll here.
            if (localStorage.getItem("maintenance") === "true") {
                console.warn("🚧 Maintenance mode - skipping auth init");
                setLoading(false);
                return;
            }

            try {
                const storedUser = await authService.getCurrentUser();
                if (storedUser) {
                    setUser(storedUser);
                }
            } catch (error) {
                console.error("Error fetching current user:", error);
            } finally {
                setLoading(false);
            }
        };

        initAuth();
    }, []);

    const login = async (employee_id, password, recaptchaValue, ip) => {

        // 🚧 BLOCK login during maintenance — throw so the Login page shows an error
        if (localStorage.getItem("maintenance") === "true") {
            throw new Error("System is under maintenance. Please try again later.");
        }

        const response = await authService.login(employee_id, password, recaptchaValue, ip);
        setUser(response.user || response);
        return response;
    };

    const logout = async () => {
        await authService.logout();
        setUser(null);
    };

    const refreshToken = async () => {
        const response = await authService.refreshToken();
        if (response.accesstoken) {
            setUser(prev => ({
                ...prev,
                accesstoken: response.accesstoken
            }));
        }
        return response;
    };

    const value = {
        user,
        loading,
        login,
        logout,
        refreshToken
    };

    return (
        <AuthContext.Provider value={value}>
            {!loading && children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};